(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('localization-form')) {
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };

        if (!this.elements.input || !this.elements.button || !this.elements.panel) return;

        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onContainerKeyUp = this.onContainerKeyUp.bind(this);

        this.elements.button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggleSelector();
        });

        this.elements.panel.addEventListener('click', (event) => event.stopPropagation());
        this.addEventListener('keyup', this.onContainerKeyUp);
        document.addEventListener('click', this.onDocumentClick);

        this.querySelectorAll('a[data-value]').forEach((item) => {
          item.addEventListener('click', this.onItemClick.bind(this));
        });
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
      }

      get isOpen() {
        return !this.elements.panel.hasAttribute('hidden');
      }

      getBackdrop() {
        let backdrop = document.querySelector('.localization-selector-backdrop');

        if (!backdrop) {
          backdrop = document.createElement('button');
          backdrop.type = 'button';
          backdrop.className = 'localization-selector-backdrop';
          backdrop.setAttribute('aria-label', 'Close country and language selector');
          backdrop.hidden = true;
          document.body.appendChild(backdrop);
        }

        return backdrop;
      }

      showBackdrop() {
        const backdrop = this.getBackdrop();
        backdrop.hidden = false;
        backdrop.onclick = () => this.hidePanel();
        document.body.classList.add('localization-selector-open');
      }

      hideBackdropIfUnused() {
        const anyOpen = Array.from(document.querySelectorAll('localization-form')).some(
          (form) => form.isOpen
        );

        if (anyOpen) return;

        const backdrop = document.querySelector('.localization-selector-backdrop');
        if (backdrop) backdrop.hidden = true;
        document.body.classList.remove('localization-selector-open');
      }

      hidePanel() {
        if (!this.elements.panel) return;
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', '');
        this.hideBackdropIfUnused();
      }

      showPanel() {
        document.querySelectorAll('localization-form').forEach((form) => {
          if (form !== this && typeof form.hidePanel === 'function') form.hidePanel();
        });

        this.elements.panel.removeAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', 'true');
        this.showBackdrop();

        const activeLink = this.elements.panel.querySelector('[aria-current="true"]');
        const firstLink = this.elements.panel.querySelector('a[data-value]');
        (activeLink || firstLink)?.focus({ preventScroll: true });
      }

      toggleSelector() {
        if (this.isOpen) {
          this.hidePanel();
        } else {
          this.showPanel();
        }
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hidePanel();
        this.elements.button.focus();
      }

      onDocumentClick(event) {
        if (this.isOpen && !this.contains(event.target)) this.hidePanel();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        this.hidePanel();
        if (form) form.submit();
      }
    }

    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = Array.from(this.querySelectorAll('predictive-search'));

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // iOS fires scroll/viewport events when its keyboard opens or closes.
      // Never hide the sticky header or close search while either search dialog
      // is visibly open, even before predictive results have loaded.
      if (this.header.querySelector('details-modal.header__search details[open]')) return;
      if (this.predictiveSearches.some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal.header__search');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
